/**
 * Created by USER on 18/4/24.
 */
import React, { Component } from 'react';
import { Player } from 'video-react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Icon, Carousel, message} from 'antd';
import ImgList from '../images/img';
import SingleTheme from '../component/single_advantage';
import {changeBarState } from '../redux/actions/headerbar_action';
import httpClient from '../swagger/swagger';
import SingleBanner from '../component/single_banner';
import {getBanner} from '../redux/actions/home_page_action';
import {getAnnouncement} from '../redux/actions/announcement_action';

const { client } = httpClient;

let timetravel; // 全局定时器函数，为了组件销毁时找到并销毁
let self; // 设置全局并赋予this 解决函数this指向的问题
const bannerData = ImgList.img.bannerImg; // banner的数据，后面根据state反复调用
class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoDisabled: 'none',
      offsetWidth: 0,
      partners: this.props.homePageReducer.partnerData,
      pointnum: '',
      imgAnimation: null,
      companyRouteTransform: 0,
      leftDisable: true,
      rightDisable: false
    };
    self = this;
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('home_page'));
    this.getAnnoumcementList();
    const {partners} = this.state;
    if (partners.length < 1) {
      client.then((oclient) => { // 请求友链的信息
        oclient.apis.partner.get_v1_partner_links({}).then((res) => {
          if (res.obj.code !== 200) {
            message.error(res.obj.message);
          } else {
            this.setState({
              partners: res.obj.data,
            })
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    }
  }

  componentDidMount() {
    setTimeout(() => { // 但页面切换时 滚动至顶部
      window.scrollTo(0, 0);
    }, 500);
    const isZH = this.props.t('language') === 'zh';
    this.changeBanner(isZH); // 页面加载需要设置此时的界面为中英文，是否为h5

    window.onresize = () => { // 浏览器窗口大小改变时，去做判断，改变图片
      const isZH = this.props.t('language') === 'zh';
      this.changeBanner(isZH)
    };
    const self = this;
    this.circleTimer(self); // banner 定时器
  }

  checkAnnouncement(id) { // 切换公告判断设备的大小从而去判断是否打开新的页面
    const {offsetWidth} = document.body;
    if (offsetWidth > 768) {
      this.props.history.push(`/announcement?Notice_id=${id}`);
    } else {
      this.props.history.push(`/announcement_detail?Notice_id=${id}`);
    }
  }

  circleTimer(self) { // 页面初始化完成后 banner定时器开始工作
    const intervalTime = (5 * 1000) / 360; // 定时器间隔时间（1度）
    let pointnum = ''; // 初始化polyline的points属性值
    const radius = 18; // 半径为时钟半径
    let x;
    let y;
    let radian;
    let angle = 0;
    let face = document.getElementById('lazy');

    // 时间轴流动
    timetravel = setInterval(() => { // 转完一圈停止
      // 角度转弧度
      radian = angle * (Math.PI / 180);

      // 计算x,y坐标值
      x = (radius + (Math.sin(radian) * radius) + 5).toFixed(1);
      y = ((radius - (Math.cos(radian) * radius)) + 5).toFixed(1);

      // 增加points属性值
      pointnum += x + ',' + y + ' ';
      face.setAttribute('points', pointnum);
      angle++;
      if (angle >= 360) {
        face.setAttribute('points', '');
        clearInterval(timetravel);
        this.refs.carousel.next();
        this.circleTimer(self);
      }
    }, intervalTime);
  }

  showVideo() { // 点击播放
    this.refs.player.play();
    this.setState({
      videoDisabled: 'block'
    });
  }

  hideVideo() { // 隐藏播放器
    this.refs.player.pause();
    this.setState({
      videoDisabled: 'none'
    });
  }

  nextCarousel() { // 点击下一个banner 清除定时器 并且重新开始画圆
    let face = document.getElementById('lazy');
    this.refs.carousel.next();
    if (timetravel) {
      clearInterval(timetravel);
    }
    face.setAttribute('points', '');
    this.circleTimer(this);
  }

  nextPage() { // 跳至下一屏
    const elements = document.getElementsByClassName('advantage_area')[0];
    const scrolldelay = setInterval(() => {
      window.scrollBy(0, 10);
      const sTop = document.documentElement.scrollTop + document.body.scrollTop;
      if (sTop >= elements.offsetTop - 45) clearInterval(scrolldelay);
    }, 10);
  }

  switchAnimation() { // 按钮选中的爆炸效果动画
    const {imgAnimation} = this.state;
    if (imgAnimation === true) {
      this.setState({
        imgAnimation: false
      })
    } else {
      this.setState({
        imgAnimation: true
      })
    }
  }

  moveLeft(leftDisable) { // 公司发展历程向左滑动，执行move距离，计算滑动整个dom的宽度以及是否能再次移动
    self.setState({
      rightDisable: false
    });
    if (!leftDisable) {
      const {companyRouteTransform} = this.state;
      const target = companyRouteTransform + 200;
      let translate = companyRouteTransform;
      const id = setInterval(frame, 10);
      function frame() {
        if (translate == target) {
          clearInterval(id);
        } else {
          translate += 50;
          self.setState({
            companyRouteTransform: translate
          });
          if (translate >= 0) {
            clearInterval
            self.setState({
              leftDisable: true,
              companyRouteTransform: 0
            })
          }
        }
      }
    }
  }

  moveRight(rightDisable) { // 公司发展历程向右滑动
    this.setState({
      leftDisable: false
    });
    if (!rightDisable) {
      const elem = document.getElementById("company_route_img_area");
      const imgElem = document.getElementById("company_route_img");
      const imgAreaWidth = Number((window.getComputedStyle(elem,  null).getPropertyValue("width")).split('p')[0]);
      const imgWidth = Number((window.getComputedStyle(imgElem,  null).getPropertyValue("width")).split('p')[0]);
      const translateWidth = imgWidth - imgAreaWidth;
      const {companyRouteTransform} = this.state;
      const target = companyRouteTransform - 200;
      let translate = companyRouteTransform;
      const id = setInterval(frame, 10);
      function frame() {
        if (translate == target) {
          clearInterval(id);
        } else {
          translate -= 50;
          self.setState({
            companyRouteTransform: translate
          });
          if (Math.abs(translate) > translateWidth) {
            clearInterval(id);
            self.setState({
              rightDisable: true
            })
          }
        }
      }
    }
  }

  getAnnoumcementList() { // 请求公告的列表
    client.then((oclient) => {
      oclient.apis.bulletin.get_bulletins_language({
        language: this.props.t('language'),
        limit: 3,
        page: 1,
      }).then((res) => {
        const data = res.obj;
        if (data.code === 200) {
          this.props.dispatch(getAnnouncement(data));
        } else {
          message.error(data.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  changeBanner(isZH) { // 改变banner的的data
    const {offsetWidth} = document.body;
    if (offsetWidth > 768) {
      if (isZH) {
        this.props.dispatch(getBanner(bannerData[0]))
      } else {
        this.props.dispatch(getBanner(bannerData[1]))
      }
    } else {
      if (isZH) {
        this.props.dispatch(getBanner(bannerData[2]))
      } else {
        this.props.dispatch(getBanner(bannerData[3]))
      }
    }
  }

  componentWillReceiveProps(nextProps){ // 判断下一次状态的改变
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      const isZH = nextProps.appBarReducer.language === 'zh';
      this.changeBanner(isZH);
      this.getAnnoumcementList();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => {});
    window.removeEventListener('resize', () => {});
    if (timetravel) clearInterval(timetravel);
  }

  render() {
    const { t } = this.props;
    const {partners, pointnum, companyRouteTransform, leftDisable, rightDisable} = this.state;
    // const imgAnimation1 = imgAnimation === null ? '' : imgAnimation === true ? 'product_img_animation_open' : 'product_img_animation_close';
    // // const imgAnimation2 = imgAnimation === null ? '' : imgAnimation === true ? 'productImgOpen' : 'productImgClose';
    // const imgAnimation3 = imgAnimation === null ? ' ' : imgAnimation === true ? 'product_img_animation_open3' : 'product_img_animation_close3';
    // const imgAnimation4 = imgAnimation === null ? ' ' : imgAnimation === true ? 'product_img_animation_open4' : 'product_img_animation_close4';
    // const imgAnimation5 = imgAnimation === null ? ' ' : imgAnimation === true ? 'product_img_animation_open5' : 'product_img_animation_close5';
    // const imgAnimation6 = imgAnimation === null ? ' ' : imgAnimation === true ? 'product_img_animation_open6' : 'product_img_animation_close6';
    const {Banner} = this.props.homePageReducer;
    const {announcement} = this.props.announcementReducer;
    const announcementData = announcement.data;
    return (
      <div>
        <div className="carousel_banner">
          <Carousel
            dots={false}
            ref="carousel"
          >
            <div className="single_banner">
              <SingleBanner
                background={Banner[0]}
                button={false}
                link="/X1"
                history={this.props.history}
              />
            </div>
            {/*<div className="single_banner appBanner">*/}
              {/*<SingleBanner*/}
                {/*background={Banner[4]}*/}
                {/*link="/X1"*/}
                {/*history={this.props.history}*/}
              {/*/>*/}
            {/*</div>*/}
            <div className="single_banner meetingBanner">
              <SingleBanner
                background={Banner[2]}
                link="/affiliates"
                history={this.props.history}
              />
            </div>
            <div className="single_banner appBanner">
              <SingleBanner
                background={Banner[1]}
                link="/download"
                history={this.props.history}
              />
            </div>
          </Carousel>
          <div
            className="carousel_switch carousel_next"
            onClick={() => this.nextCarousel()}
            onKeyPress={() => this.nextCarousel()}
          >
            <div className="circle" >
              <i className="icon iconfont icon-ArtboardCopy" />
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                <polyline id="lazy" points={pointnum} />
              </svg>
            </div>
          </div>
          {/*<a*/}
            {/*className="scroll-down"*/}
            {/*onClick={() => this.nextPage()}*/}
          {/*>*/}
            {/*<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12.1 21.1" >*/}
              {/*<polygon points="7.1,14 7.1,0 5.1,0 5.1,14 0,14 6.1,21.1 12.1,14 " />*/}
            {/*</svg>*/}
            {/*<span className="decorator" />*/}
            {/*<span className="decorator bottom right" />*/}
            {/*<span className="decorator bottom left" />*/}
            {/*<span className="decorator top left" />*/}
          {/*</a>*/}
          <div className="announcement_select">
            <Carousel
              dots={false}
              vertical
              autoplay={true}
            >
              {
                announcementData.map(item => (
                  <div
                    className="announcement_select_one"
                    onClick={() => this.checkAnnouncement(item.id)}
                    key={item.id}
                  >
                    <i className="icon iconfont icon-bk-" />
                    <span className="announcement_select_one_title">
                      {`《${item.title}》`.length > 20 ? `${item.title}`.slice(0, 19) + '...' : `${item.title}`}
                     </span>
                    <span className="announcement_select_one_time">{/\d{4}-\d{1,2}-\d{1,2}/g.exec(item.date_updated)}</span>
                  </div>
                ))
              }
            </Carousel>
          </div>
        </div>
        <div className="product_features_area">
          <img src={t('language') === 'zh' ? ImgList.img.productFeaturesZH : ImgList.img.productFeaturesEN} alt="lubanso" />
          <Link to="/x1">
            <div>{t('know_product_details')} <Icon type="arrow-right" /></div>
          </Link>
        </div>
        <div className="advantage_area">
          <div className="advantage_block">
            <SingleTheme
              themeTitle={t('theme_title_one')}
              themeDetails={[t('theme_details_one1'), t('theme_details_one2'), t('theme_details_one3')]}
              img={ImgList.img.reliable}
              icon="icon-gw-"
            />
            <SingleTheme
              themeTitle={t('theme_title_two')}
              themeDetails={[t('theme_details_two1'), t('theme_details_two2'), t('theme_details_two3')]}
              img={ImgList.img.security}
              icon="icon-gw-1"
            />
            <SingleTheme
              themeTitle={t('theme_title_three')}
              themeDetails={[t('theme_details_three1'), t('theme_details_three2')]}
              img={ImgList.img.strong}
              icon="icon-gw-2"
            />
          </div>
        </div>
        <div className="product_video">
          <Player
            playsInline
            fluid={true}
            loop={true}
            autoPlay={true}
            muted={true}
            poster="https://lubansohz.oss-cn-hangzhou.aliyuncs.com/lubanso-web/images/2018-09-12/abdece17d5ec4d84aaad7acef16dfcd8.jpg"
          >
            <source src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/media/3s.mp4" />
          </Player>
          <div className="product_video_control">
            <div
              className="product_video_play_button"
              onClick={() => this.showVideo()}
              onKeyPress={() => this.showVideo()}
            >
              <i className="icon iconfont icon-play_"/>
            </div>
          </div>
        </div>
        <div className="video-modal" style={{display: this.state.videoDisabled}}>
          <div className="hide-video" onClick={() => this.hideVideo()} onKeyPress={() => this.hideVideo()}>
            <i className="icon iconfont icon-close"/>
          </div>
          <div className="video-block">
            <Player
              playsInline
              ref="player"
              aspectRatio="16:8"
              loop={true}
            >
              <source src="https://lubanso-images.oss-cn-hangzhou.aliyuncs.com/media/%E9%B2%81%E7%8F%AD%E9%94%81-60s_%E5%BE%AE%E4%BF%A1%E7%89%88.mp4"/>
            </Player>
          </div>
        </div>
        <div className="web_app">
          <div className="web_app_head">
            <div className="web_app_img">
              <img src={t('language') === 'zh' ? ImgList.img.webApp : ImgList.img.webAppEN} alt="lubanso" />
            </div>
            <div className="web_app_head_content">
              <div>
                <div className="web_app_title">{t('web_app_advantage')}</div>
                <div className="web_app_title_notice">{t('web_app_advantage1')}</div>
                <div className="web_app_title_notice">{t('web_app_advantage2')}</div>
                <div className="web_app_title_notice">{t('web_app_advantage3')}</div>
                <Link to="/download">
                  <div className="web_app_know_more"> {t('know_more')} <Icon type="arrow-right" /></div>
                </Link>
              </div>
            </div>
          </div>
          <div className="web_app_advantage">
            <div className="single_web_app_advantage">
              <div><i className="icon iconfont icon icon-gw-3"/></div>
              <span className="single_web_app_advantage_title">{t('web_app_advantage_friendly')}</span>
              <span className="single_web_app_advantage_notice">{t('web_app_advantage_friendly1')}</span>
              <span className="single_web_app_advantage_notice">{t('web_app_advantage_friendly2')}</span>
            </div>
            <div className="single_web_app_advantage">
              <div><i className="icon iconfont icon icon-gw-4"/></div>
              <span className="single_web_app_advantage_title">{t('web_app_advantage_efficient')}</span>
              <span className="single_web_app_advantage_notice">{t('web_app_advantage_efficient1')}</span>
              <span className="single_web_app_advantage_notice">{t('web_app_advantage_efficient2')}</span>
            </div>
            <div className="single_web_app_advantage">
              <div><i className="icon iconfont icon icon-gw-5"/></div>
              <span className="single_web_app_advantage_title">{t('web_app_advantage_platform')}</span>
              <span className="single_web_app_advantage_notice">{t('web_app_advantage_platform1')}</span>
              <span className="single_web_app_advantage_notice">Mac OS</span>
            </div>
          </div>
        </div>
        <div className="multi_currency">
          <div>
            <div className="multi_currency_title">
              {t('multi_currency')}
            </div>
            <div className="multi_currency__content_did multi_currency_content_did_coin">
              <div>
                <i className="icon iconfont icon-bizhong-4" />
                <span>BTC</span>
              </div>
              {/* <div>
                <i className="icon iconfont icon-bizhong-3" />
                <span>BCH</span>
              </div> */}
              <div>
                <i className="icon iconfont icon-bizhong-5" />
                <span>EOS</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-14" />
                <span>USDT</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-1" />
                <span>LTC</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-2" />
                <span>BCD</span>
              </div>
              <div className="support_soon">
                <i className="icon iconfont icon-bizhong-19" />
                <span>{t('supportSoon')}</span>
              </div>
            </div>
            <div className="multi_currency__content_did multi_currency_content_did_token">
              <div>
                <i className="icon iconfont icon-bizhong-" />
                <span>ETH</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-8" />
                <span>BNB</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-11" />
                <span>ZRX</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-7" />
                <span>OMG</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-6" />
                <span>BAT</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-18" />
                <span>PAX</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-13" />
                <span>ZIL</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-12" />
                <span>AE</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-10" />
                <span>LINK</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-16" />
                <span>IOST</span>
              </div>
              <div>
                <i className="icon iconfont icon-bizhong-17" />
                <span>ELF</span>
              </div>
              <div className="multi_currency_more">
                <i>...</i>
                <span>{t('supportERC1')}</span>
                <span>{t('supportERC2')}</span>
              </div>
            </div>
            <div className="multi_currency__content_did multi_currency_content_did_token">
              <div>
                <i className="icon iconfont icon-bizhong-5" />
                <span>EOS</span>
              </div>
              <div>
                <i className="icon iconfont icon-NDX" />
                <span>NDX</span>
              </div>
              <div>
                <i className="icon iconfont icon-MEETONE" />
                <span>MEETONE</span>
              </div>
              <div>
                <i className="icon iconfont icon-WAL" />
                <span>WAL</span>
              </div>
              <div>
                <i className="icon iconfont icon-EOSDAC" />
                <span>EOSDAC</span>
              </div>
              <div>
                <i className="icon iconfont icon-IQ" />
                <span>IQ</span>
              </div>
              <div>
                <i className="icon iconfont icon-eBTC" />
                <span>eBTC</span>
              </div>
              <div>
                <i className="icon iconfont icon-eETH" />
                <span>eETH</span>
              </div>
              <div className="multi_currency_more">
                <i>...</i>
                <span>{t('supportERC1')}</span>
                <span>EOS Token</span>
              </div>
            </div>
            {/* <div className="multi_currency_details">
              <div>
                <div className="multi_currency_details_icon">
                  <i className="icon iconfont icon-y-" />
                </div>
                <div className="multi_currency_details_coin">
                  <span>BTC ETH EOS USDT LTC BCD ERC-20 EOS-Token</span>
                  <span> {t('multi_currency_did')}</span>
                </div>
              </div>
              <div>
                <div className="multi_currency_details_icon">
                  <i className="icon iconfont icon-y-1" />
                </div>
                <div className="multi_currency_details_coin">
                  <span>BSV &nbsp;</span>
                  <span>ADA</span>
                  <span> {t('multi_currency_now')}</span>
                </div>
              </div>
              <div>
                <div className="multi_currency_details_icon">
                  <i className="icon iconfont icon-y-2" />
                </div>
                <div className="multi_currency_details_coin">
                  <span>DASH ETC &nbsp;</span>
                  <span>XMR XLM</span>
                  <span> {t('multi_currency_will')}</span>
                </div>
              </div>
            </div> */}
            <div className="currency_banner" style={{background: `url(${ImgList.img.currencyBanner})`}}>
              <div>
                <div className="currency_banner_left">
                  <h2>{t('currency_banner_title')}</h2>
                  <p>{t('currency_banner_details')}</p>
                </div>
                <div className="currency_circle">
                  <div className="currency_circle1"></div>
                  <div className="currency_circle4"/>
                  <div className="currency_circle2">
                    <span />
                    <span />
                    <span />
                  </div>
                  <div className="currency_circle3">
                    {/* <span>Eos</span>
                    <span>Token</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="company_route"
        >
          <div
            className="company_route_img_area"
            id="company_route_img_area"
          >
            <img
              src={t('language') === 'zh' ? ImgList.img.companyRouteWeb : ImgList.img.companyRouteWebEn}
              alt="lubanso"
              className="company_route_img"
              style={{transform: `translateX(${companyRouteTransform}px)`}}
              id="company_route_img"
            />
          </div>
          <div className="route_switch" >
            <div
              className="company_route_switch"
              onClick={() => this.moveLeft(leftDisable)}
            >
              <i
                className="icon iconfont icon-ArtboardCopy1"
                style={{color: leftDisable ? '#ddd' : '#FFF'}}
              />
            </div>
            <div
              className="company_route_switch"
              onClick={() => this.moveRight(rightDisable)}
            >
              <i
                className="icon iconfont icon-ArtboardCopy"
                style={{color: rightDisable ? '#ddd' : '#FFF'}}
              />
            </div>
          </div>
        </div>
        <div className="partners_block">
          <div className="partners">
            {/* <div className="partners_title">{t('brands')}</div>
            <div className="partners_area partners_platform">
              {
                ImgList.img.checkInPlatform.map((item, index) => (
                  <a
                    key={index}
                    className="single_partner"
                    href={item.url}
                    target="_blank"
                  >
                    <img src={item.img} alt="LUBANSO" />
                  </a>
                ))
              }
            </div> */}
            <div className="partners_title">{t('partners')}</div>
            <div className="partners_area">
              {
                partners.map((item) => (
                  <a
                    key={item.id}
                    className="single_partner"
                    href={item.link}
                    target="_blank"
                  >
                    <img src={item.logo} alt="LUBANSO" />
                  </a>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    appBarReducer: state.appBarReducer,
    homePageReducer: state.homePageReducer,
    announcementReducer: state.announcementReducer
  };
}

const HomePageConnected = connect(select)(HomePage);

export default translate('translations')(HomePageConnected);
